import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as revealActions from '../../../../actions/revealActions';
import * as accountActions from '../../../../actions/accountActions';
import Reveal from '../../../common/reveal/Reveal';
import { TRANSLATE_TAG } from '../../../../const';
import HeaderReveal from '../../../common/reveal/HeaderReveal';
import { SmartButton } from '../../../common/SmartButton';

export const RECOVER_USER_PASSWORD_REVEAL = 'recoverUserPasswordReveal';

export class UserPasswordRecoverReveal extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.closeReveal = this.closeReveal.bind(this);
    this.handlePasswordRecoverUser = this.handlePasswordRecoverUser.bind(this);
    this.state = { isActiveRecoverButton: true };
  }

  closeReveal() {
    this.props.revealActions.setOpenReveal();
  }

  handlePasswordRecoverUser() {
    const { user, accountActions } = this.props;
    accountActions.requestNewPassword(user.email);
    this.setState({ isActiveRecoverButton: false });
    this.closeReveal();
  }

  render() {
    const { user } = this.props;

    let message = I18n.t('userProfile.recoverPassword').replace(`${TRANSLATE_TAG.TITLE}`, user.email);

    return (
      <Reveal id={RECOVER_USER_PASSWORD_REVEAL} className="small-wrapper red">
        {/* <div className="small-wrapper red"> */}

        <HeaderReveal title={I18n.t('userProfile.recoverPasswordTitle')} onCloseOnClick={this.closeReveal} />

        <div className="content">{message}</div>

        <div className="footer">
          <SmartButton onClick={this.closeReveal}>{I18n.t('common.cancel')}</SmartButton>
          <SmartButton danger onClick={this.handlePasswordRecoverUser}>
            {I18n.t('userProfile.recoverPasswordButton')}
          </SmartButton>
        </div>

        {/* </div> */}
      </Reveal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPasswordRecoverReveal);

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}
